import { MRT_ColumnDef, MRT_RowData } from "material-react-table";

export interface IProperty {
  field_type: string;
  label: string;
  placeholder: string;
  default_value?: string;
  float_step?: string;
  min_length?: number;
  max_length?: number;
  is_multiline?: boolean;
  is_required?: boolean;
  is_negative?: boolean;
  is_unique?: boolean;
  is_checked?: boolean;
  // options?: Array<{ text: string; value: string }>;
  // is_multiselect?: boolean,
  id?: string;
  is_future_dates_allowed?: boolean;
  is_past_dates_allowed?: boolean;
  option?: string;
  max_size?: number;
  section_id?: string;
  section_name?: string;
  title_position?: "start" | "end"
  title?:string,
  table_columns?:MRT_ColumnDef<MRT_RowData>[]
  table?:string
  module?:string
  field?:string
  is_country_code_separate?: boolean;
  country_code_field_name?: string;
}

interface IMultiOption {
  value: string;
  label: string;
  is_checked: boolean;
}

export interface IMultiOptionsProperty extends IProperty {
  options: IMultiOption[];
  display?: "row" | "column";
}

export interface ISelectProperty {
  field_type: string;
  label: string;
  placeholder: string;
  default_value: string;
  is_required?: boolean;
  is_unique?: boolean;
  options: ISelectOption[];
  is_multiselect?: boolean;
  id?: string;
  section_id?: string;
  section_name?: string;
}

export interface ISwitcherForms {
  value?: string;
  name: string;
  id: string | number | null;
}

export interface ISectionProperty {
  field_type: string;
  label: string;
  is_accordion: boolean;
  id?: string;
  section_order?: string;
  section_id?: string;
  section_name?: string;
  section_type: "Default" | "Form switcher section";
  form_switcher_label?: string;
  form_switcher_name?: string;
  switcher_forms?: ISwitcherForms[];
  members: IProperty[] | ISelectProperty[];
}


interface ISelectOption {
  text: string;
  value: string;
}

const text: IProperty = {
  field_type: "text",
  label: "label",
  placeholder: "Enter text",
  default_value: "",
  min_length: 2,
  max_length: 30,
  is_multiline: false,
  is_required: true,
  is_unique: false,
};

const number: IProperty = {
  field_type: "number",
  label: "label",
  placeholder: "Enter number",
  default_value: "",
  float_step: "0.001", // "0.001",
  min_length: 0,
  max_length: 1000,
  is_negative: false,
  is_required: true,
  is_unique: false,
};

const email: IProperty = {
  field_type: "email",
  label: "label",
  placeholder: "Enter email",
  default_value: "",
  is_required: false,
  is_unique: false,
};

const phone: IProperty = {
  field_type: "phone",
  label: "label",
  placeholder: "Enter phone",
  default_value: "",
  is_required: false,
  is_unique: false,
};

const select: ISelectProperty = {
  field_type: "select",
  label: "Select",
  placeholder: "Choose option",
  default_value: "",
  options: [],
  is_multiselect: false,
  is_required: true,
  is_unique: false,
};

const date: IProperty = {
  field_type: "date",
  label: "label",
  placeholder: "Select Date",
  default_value: "",
  is_future_dates_allowed: false,
  is_past_dates_allowed: false,
  is_required: false,
  is_unique: false,
};

const time: IProperty = {
  field_type: "time",
  label: "label",
  placeholder: "Select Time",
  default_value: "",
  is_required: false,
  is_unique: false,
  option: "12hr",
};

const url: IProperty = {
  field_type: "url",
  label: "label",
  placeholder: "Enter URL",
  default_value: "",
  is_required: false,
  is_unique: false,
};

const currency: IProperty = {
  field_type: "currency",
  label: "label",
  placeholder: "Enter Currency",
  default_value: "",
  is_required: false,
  is_unique: false,
  option: "inr",
};

const file: IProperty = {
  field_type: "file",
  label: "label",
  placeholder: "Upload File or Media",
  is_required: false,
  is_unique: false,
  max_size: 20,
  default_value: "",
};

const image: IProperty = {
  field_type: "image",
  label: "label",
  placeholder: "Upload Image",
  is_required: false,
  is_unique: false,
  max_size: 20,
  default_value: "",
};

const geoLocation: IProperty = {
  field_type: "geoLocation",
  label: "label",
  placeholder: "Enter geo location",
  default_value: "",
  is_required: false,
  is_unique: false,
};

const section: ISectionProperty = {
  field_type: "section",
  label: "section",
  section_type: "Default",
  form_switcher_label: "Form section",
  form_switcher_name: "",
  switcher_forms: [{
    value: "",
    name: "Form 1",
    id: null,
  }],
  is_accordion: false,
  members: [],
};

const info: IProperty = {
  field_type: "info",
  label: "label",
  placeholder: "Add Label Text",
  default_value: "",
};

const relation: IProperty = {
  field_type: "relation",
  label: "label",
  placeholder: "Add Label Text",
  is_required: false,
  is_unique: false,
  module: "",
  field: "",
  default_value: "",
};

const checkbox: IProperty = {
  field_type: "checkbox",
  label: "label",
  placeholder: "Add Label Text",
  is_required: false,
  is_checked: false,
  title_position:'end',
  title:"Checkbox"
};

const toggleButton: IProperty = {
  field_type: "toggleButton",
  label: "label",
  placeholder: "Add Label Text",
  is_required: false,
  is_checked: false,
  title_position:'end',
  title:"Toggle"
};

const table: IProperty = {
  field_type: "table",
  label: "label",
  placeholder: "Add Label Text",
  is_required: false,
  table_columns: [],
  table: "custom",
};
const radioButton: IMultiOptionsProperty = {
  field_type: "radioButton",
  placeholder: "",
  label: "label",
  title: "",
  is_required: false,
  title_position:'end',
  options: [],
  display: "row",
  default_value: "",
};
const tagsInput: IProperty = {
  field_type: "tagsInput",
  label: "label",
  placeholder: "Enter tagsInput",
  default_value: "",
  min_length: 2,
  max_length: 30,
  is_multiline: false,
  is_required: true,
  is_unique: false,
};

export const element = {
  text,
  number,
  email,
  phone,
  select,
  date,
  time,
  url,
  currency,
  file,
  geoLocation,
  image,
  section,
  info,
  relation,
  checkbox,
  toggleButton,
  radioButton,
  table,
  tagsInput
};
